export default "__VITE_ASSET__b5f297ec__"